import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { ProgressBar } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import ReactDOMServer from "react-dom/server";
import { AppNotificationAlert } from "@/layout/AppComponents";
import AppModal from "../../../components/Modal/AppModal";
import Translator from "../../../components/helpers/Translator";
import errorHandler from "@/layout/components/error/ErrorHandler";
import { axiosPath } from "../../../../routing/helpers/router";
import useIsMounted from "../../../components/hooks/useIsMounted";

const GenerateReport = (props) => {
  const dispatch = useDispatch();
  const { moduleBridgeHex, values, onFinish, getModalInfo, comment, onError } =
    props;
  const global = useSelector((state) => state.global);
  const isMounted = useIsMounted();
  const [reportData, setReportData] = useState();
  const [modalInfo, setModalInfo] = useState({
    percent: 1,
    message: ReactDOMServer.renderToString(
      <Translator file="module-intelligence" name="preparing.information" />,
    ),
  });
  const [calcReport, setCalcReport] = useState(null);

  // > GET REPORT
  useEffect(() => {
    setReportData({
      moduleBridgeHex,
      values,
      locale: global.urlData.lang,
      modalInfo,
      isStoreReport: !!getModalInfo,
      comment: comment || null,
    });
    if (getModalInfo) getModalInfo(modalInfo);
    setCalcReport(0);
  }, []);

  const handleCalcReport = async () => {
    await axios
      .post(axiosPath("api_r_user_m_intelligence_calculateReport"), reportData)
      .then(({ data }) => {
        if (isMounted.current) setReportData(data);
      })
      .catch((error) => {
        AppNotificationAlert({
          title: "Error",
          message: "Se ha producido un error",
          type: "danger",
          duration: 5000,
        });
        errorHandler({
          message: "Error",
          error: {
            name: error.name,
            url: "",
            function: "handleCalcReport",
          },
        });
      });
  };

  useEffect(() => {
    if (calcReport) {
      handleCalcReport();
    }
  }, [calcReport]);

  useEffect(() => {
    if (reportData && !reportData.isFinished) {
      setModalInfo(reportData.modalInfo);
      if (getModalInfo) getModalInfo(reportData.modalInfo);
      setCalcReport(calcReport + 1);
    } else if (reportData && reportData.isFinished) {
      if (!reportData.onlineInfo) onFinish(reportData.reportUrl || true);
      else onFinish(reportData);
    }
  }, [reportData]);
  // < GET REPORT

  return (
    <>
      <AppModal
        size="lg"
        show={!getModalInfo}
        isCloseButton={false}
        title={<Translator file="module-intelligence" name="loading.results" />}
      >
        <h2>{modalInfo.message}</h2>
        <ProgressBar
          animated
          now={modalInfo.percent}
          label={`${parseInt(modalInfo.percent)}%`}
        />
      </AppModal>
    </>
  );
};

export default GenerateReport;
